module.exports = __webpack_public_path__ + "media/application/images/Senza-titolo-1-68708d1444e2d47042dcfdd5cb9dc20b.jpg";